var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productDetail)?_c('product-form',{attrs:{"product":_vm.productDetail},on:{"submit":_vm.update}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }